module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-normal.0f35f9bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/primary-normal.png
// module id = 3066
// module chunks = 11